<script setup lang="ts">
type LemonProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<LemonProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 619.53 614.19"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d" />
    <g id="e" />
    <g id="f">
      <path
        class="u"
        :fill="getColor('#f5c455')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M606.42,566.74c-31.43,29.37-70.67-10.09-105.72-5.95-19.34,2.29-38.03,17.19-56.59,23.52-33.96,11.59-70.45,15.14-106.07,12.1-77.3-6.61-145.47-49.9-203.33-95.01C59.52,442.78,22.57,360.67,17.51,266.98c-2.01-37.31,7.62-74.56,5.99-110.46-.8-17.58-11.85-33.22-8.2-51.08C24.94,58.13,62.16,39.25,105.46,30.97c16.16-3.09,28.84,2.01,44.72,2.32,21.13,.42,41.34-8.64,61.63-13.19,43.33-9.73,95.99-2.81,137.05,13.4,78.91,31.15,142.18,82.87,185.99,156.41,34.05,57.15,56.61,127,57.96,194.75,.45,22.66-6.83,45.15-4.27,67.41,2.7,23.54,13.85,48.07,18.37,71.81,1.71,9,2.36,17.82-.49,42.86Z"
      />
    </g>
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
